import { ApolloClient, ApolloLink } from '@apollo/client/core';
import { InMemoryCache } from '@apollo/client/cache';
import { createHttpLink } from '@apollo/client/link/http';
import { breadcrumbLink } from '@getaccept/lib-shared/src/bugsnag';
import { UrlHelper } from '@getaccept/lib-shared/src/helpers/url.helper';
import { getPrefixedInternalApiBaseUrl } from '../helpers/get-prefixed-api-base-url';
import { useAuthStore } from './session/store/auth.store';
import { errorLink } from './error-link';
const intBaseUrl = import.meta.env.VUE_APP_INTERNAL_API_BASE_URL;
const domain = intBaseUrl
  ? getPrefixedInternalApiBaseUrl(intBaseUrl, window.location.hostname)
  : 'localhost:3001';

const httpLink = createHttpLink({
  uri: ({ operationName }) => UrlHelper.getHttpsUrl(`${domain}/graphql?op=${operationName}`),
});

const getAuthToken = () => {
  const authStore = useAuthStore();
  return `Bearer ${authStore.token}`;
};

const authLink = new ApolloLink((operation, forward) => {
  if (operation.getContext().headers?.authorization) {
    operation.setContext({
      headers: { authorization: operation.getContext().headers?.authorization },
      disableTokenRetry: true,
    });
    return forward(operation);
  }
  operation.setContext({ headers: { authorization: getAuthToken() } });
  return forward(operation);
});

export const apolloClientInternal = new ApolloClient({
  link: ApolloLink.from([authLink, breadcrumbLink, errorLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      // The PricingSummaryTables in the tables array in the Pricing Summary nodes has a field
      // 'id', that is not the id of the PricingSummaryTable but used to identify the Pricing Table
      // in the document. Apollo normalizes the cache by the id field, so we need to disable the
      // keyFields for the PricingSummaryTable type.
      PricingSummaryTable: {
        keyFields: false,
      },
    },
    possibleTypes: {
      Effect: [
        'DocumentUpdateEffect',
        'RecipientUpdateEffect',
        'EditorSectionUpdateEffect',
        'EditorRowUpdateEffect',
        'EditorNodeUpdateEffect',
      ],
    },
  }),
  queryDeduplication: false,
});
